import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.autoBilling;
const getResponseListAutoBilling = (state: AppState) => state.autoBilling.responseListAutoBilling;
const getPendingListAuto = (state: AppState) => state.autoBilling.statusListAuto;
const getResValidCustomer = (state: AppState) => state.autoBilling.responseValidCustomer;
const getDataCreate = (state: AppState) => state.autoBilling.dataCreate;
const getHasCreated = (state: AppState) => state.autoBilling.isCreated;
const getResponseCreated = (state: AppState) => state.autoBilling.responseCreate;
const getResponseAuth = (state: AppState) => state.autoBilling.responseAuth;
const getHasAuthorization = (state: AppState) => state.autoBilling.isAuthorization;
const getResponseTransaction = (state: AppState) => state.autoBilling.responseTransaction;
const getPendingTransaction = (state: AppState) => state.autoBilling.statusTransaction;

export const getAutoBillingStoreSelector = createSelector(getStore, (data) => data);
export const getAutoBillingListSelector = createSelector(getResponseListAutoBilling, (data) => data);
export const getAutoBillingPendingListAutoSelector = createSelector(getPendingListAuto, (status) => status);

export const getAutoBillingResValidCustomerSelector = createSelector(getResValidCustomer, (data) => data);

export const getAutoBillingDataCreateSelector = createSelector(getDataCreate, (data) => data);

export const getAutoBillingHasCreatedSelector = createSelector(getHasCreated, (status) => status);
export const getAutoBillingResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getAutoBillingHasAuthorizationSelector = createSelector(getHasAuthorization, (status) => status);
export const getAutoBillingResponseAuthSelector = createSelector(getResponseAuth, (res) => res);

export const getAutoBillingTransactionSelector = createSelector(getResponseTransaction, (data) => data);
export const getAutoBillingPendingTransactionSelector = createSelector(getPendingTransaction, (data) => data);
